import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { BookingForm } from "../components/BookingForm";

export default function Booking() {
  const { copy } = useLanguage();
  const b = copy.booking;

  return (
    <main className="pt-28 pb-24 sm:pt-36" data-testid="booking-page">
      <Seo title={copy.seo.booking.title} description={copy.seo.booking.desc} />
      <div className="max-w-2xl mx-auto px-5">
        <Reveal>
          <div className="text-center mb-10">
            <p className="text-xs font-mono uppercase tracking-[0.22em] text-clay font-semibold mb-3">{b.eyebrow}</p>
            <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-ink tracking-tight" data-testid="booking-title">{b.title}</h1>
            <p className="mt-4 text-muted" data-testid="booking-subtitle">{b.sub}</p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-3xl bg-white border border-border p-6 sm:p-9 shadow-sm">
            <BookingForm />
          </div>
        </Reveal>
      </div>
    </main>
  );
}
